import { render } from "./CreationWorkManage.vue?vue&type=template&id=38e5ac7c&scoped=true"
import script from "./CreationWorkManage.vue?vue&type=script&lang=js"
export * from "./CreationWorkManage.vue?vue&type=script&lang=js"

import "./CreationWorkManage.vue?vue&type=style&index=0&id=38e5ac7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e5ac7c"]])

export default __exports__